<app-compiler-compose (submit)="onCompilerSubmit($event)" (cancel)="onCompilerCancel($event)" (clear)="onCompilerClear($event)" [data]="compiler"></app-compiler-compose>
